// The explicit multi-selection when one exists, else the active slide alone.
// The empty-selection fallback is load-bearing: a caller that reads this live
// during a modal flow can silently collapse to a single slide once the
// selection is cleared, which is why the apply path snapshots it at modal-open.
const getSelectedSlides = (state) => {
  const selected =
    state.selections.selectedSlideIds.length && state.selections.selectedSlideIds.some((id) => id !== null)
      ? state.selections.selectedSlideIds
      : [state.slideActive.id]

  return state.presentation.slides
    .filter((slide) => selected.some((id) => id === slide.id))
    .sort((a, b) => a.order - b.order)
}

export default getSelectedSlides
